<!-- TODO: da completare -->
<div class="it-hero-wrapper it-dark it-overlay it-bottom-overlapping-content">
    <div class="img-responsive-wrapper">
        <div class="img-responsive">
            <div class="img-wrapper">
                <img src="assets/img/tmp-home-hero.jpg" title="img title" alt="Immagine hero" />
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row justify-content-end">
            <div class="col-4">
                <div class="it-hero-text-wrapper bg-dark pr-0">
                    <div class="it-hero-text-inner">
                        <h1>Opere di Difesa del Suolo</h1>
                        <p class="d-none d-lg-block">
                            Accedi al sistema informativo dedicato alle Opere di Difesa del Suolo (ODS) per consultare, aggiornare e organizzare le informazioni funzionali al monitoraggio, alla gestione e manutenzione delle opere esistenti in Lombardia.
                        </p>
                        <div class="it-btn-container">
                            <button class="btn btn-lg btn-primary" type="button" (click)="login()">Accedi</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container">
    <div class="row">
        <div class="col-12">
            <div class="card-wrapper card-space">
                <div class="card card-bg">
                    <div class="card-body">
                        <!-- <h5 class="card-title">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                            eiusmod tempor…
                        </h5> -->
                        <p class="card-text">
                            Il sistema informativo dedicato alle Opere di Difesa del Suolo (ODS) raccoglie ed organizza le informazioni relative alle Opere realizzate in Lombardia finalizzate alla mitigazione del rischio idraulico-idrogeologico, suddivise nelle seguenti categorie: opere idrauliche, opere di difesa massi, opere di difesa valanghe, opere di drenaggio, opere di sostegno, opere di stabilizzazione superficiale, opere speciali , monitoraggi ed indagini.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row my-5">
        <div class="col-12 col-lg-4">
            <div class="callout important">
                <div class="callout-title">
                    <app-toolkit-bl-icon icon="info-circle"></app-toolkit-bl-icon>
                    <!-- Lorem ipsum dolor -->
                </div>
                <article>Solo per consultare il catasto delle Opere di Difesa del suolo <a href="https://www.geoportale.regione.lombardia.it/metadati?p_p_id=detailSheetMetadata_WAR_gptmetadataportlet&p_p_lifecycle=0&p_p_state=normal&p_p_mode=view&_detailSheetMetadata_WAR_gptmetadataportlet_identifier=r_lombar%3A2287928c-a31f-45bb-b821-d170811134e4&_jsfBridgeRedirect=true">clicca qui</a></article>
            </div>
        </div>
        <div class="col-12 col-lg-4">
            <div class="callout important">
                <div class="callout-title">
                    <app-toolkit-bl-icon icon="info-circle"></app-toolkit-bl-icon>
                    <!-- Lorem ipsum dolor -->
                </div>
                <article>Per segnalare le esigenze di nuove opere di Difesa del Suolo <a href="https://www.bandi.servizirl.it/procedimenti/welcome/idpc/page">clicca qui</a></article>
            </div>
        </div>
        <div class="col-12 col-lg-4">
            <div class="callout important">
                <div class="callout-title">
                    <app-toolkit-bl-icon icon="info-circle"></app-toolkit-bl-icon>
                    <!-- Lorem ipsum dolor -->
                </div>
                <article>Guida all'inserimento delle opere nel catasto <a style="color: #2a7a38; text-decoration: none;" onmouseover="this.style.textDecoration='underline'" onmouseout="this.style.textDecoration='none'" (click)="downloadManuale()">clicca qui</a></article>
            </div>
        </div>
    </div>
</div>